import NProgress from "nprogress";

export default function() {
  const mapElement = document.getElementById("offices-map");
  if (!mapElement) return;

  const officeMap = new google.maps.Map(mapElement, {
    zoom: 2,
    center: { lat: 19.767622405758452, lng: -1.1435000000000173 },
  });

  officeMap.setMapTypeId(google.maps.MapTypeId.SATELLITE);

  const pinYellow = "/wp-content/themes/USGBC/images/spotlight-poi-yellow.png";
  const pinBlue = "/wp-content/themes/USGBC/images/spotlight-poi-blue.png";
  const pinRed = "/wp-content/themes/USGBC/images/spotlight-poi.png";

  let markers = [];

  function addMarker(item) {
    const lat = item.acf.latitude,
      lng = item.acf.longitude,
      itemTitle = item.title.rendered,
      officeType = item.acf.office_type,
      itemLink = item.link;

    let message = "View representive info";
    let itemIcon = pinRed;

    if (officeType) {
      if (officeType === "regional") {
        itemIcon = pinBlue;
        message = "View office info";
      } else if (officeType === "country") {
        itemIcon = pinYellow;
        message = "View office info";
      } else if (officeType === "representatives") {
        itemIcon = pinRed;
        message = "View representive info";
      } else {
        itemIcon = pinRed;
        message = "View representive info";
      }
      //itemIcon = officeType === "regional" ? pinBlue : pinYellow;
      //message = "View office info";
    }

    const contentString = `<div id="content">
                                <div class="text-lg mb-2"><b>${itemTitle}</b></div>
                                <a href="${itemLink}">${message}</a>
                            </div>`;

    const infowindow = new google.maps.InfoWindow({
      content: contentString,
    });

    const marker = new google.maps.Marker({
      title: itemTitle,
      position: {
        lat: parseInt(lat),
        lng: parseInt(lng),
      },
      map: officeMap,
      icon: itemIcon,
      infowindow: infowindow,
    });

    markers.push(marker);

    google.maps.event.addListener(marker, "click", function() {
      hideAllInfoWindows();
      this.infowindow.open(officeMap, this);
    });
  }

  function hideAllInfoWindows() {
    markers.forEach(function(marker) {
      marker.infowindow.close(officeMap, marker);
    });
  }

  (function($) {
    $(function() {
      NProgress.start();
      $.ajax({
        url: "/wp-json/wp/v2/office",
        data: {
          per_page: 100,
        },
      })
        .then((response) => {
          response.forEach((office) => {
            addMarker(office);
          });
        })
        .always(() => {
          NProgress.done();
        });

      NProgress.start();
      $.ajax({
        url: "/wp-json/wp/v2/consultant",
        data: {
          per_page: 100,
        },
      })
        .then((response) => {
          response.forEach((consultant) => {
            addMarker(consultant);
          });
        })
        .always(() => {
          NProgress.done();
        });

      NProgress.start();

      $.ajax({
        url: "/wp-json/wp/v2/staff",
        data: {
          per_page: 100,
        },
      })
        .then((response) => {
          response.forEach((staff) => {
            addMarker(staff);
          });
        })
        .always(() => {
          NProgress.done();
        });
    });
  })(jQuery);
}



// WEBPACK FOOTER //
// ./src/js/partials/offices-map.js